

































import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { Format } from "../core/helpers/formatHelper";
import CzPage from "../components/cz/CzPage.vue";
import CzSection from "../components/cz/CzSection.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzChip from "../components/cz/CzChip.vue";
import CzAccordion from "../components/cz/CzAccordion.vue";
import CzNotice from "../components/cz/CzNotice.vue";

@Component({
  components: { CzPage, CzSection, CzCard, CzChip, CzAccordion, CzNotice },
})
export default class MyVouchersPage extends Vue {
  data: any = null;
  errorMsg: string = "";
  opened: { [key: string]: boolean } = {};

  get groups(): any[] {
    if (!this.data) return [];
    return [
      { key: "active", title: this.$t("Active Vouchers").toString(), empty: this.$t("No active vouchers").toString(), items: this.data.active },
      { key: "inactive", title: this.$t("Inactive Vouchers").toString(), empty: this.$t("No inactive vouchers").toString(), items: this.data.inactive },
    ];
  }

  isOpen(group: string, index: number): boolean {
    return !!this.opened[group + index];
  }

  toggle(group: string, index: number) {
    this.$set(this.opened, group + index, !this.isOpen(group, index));
  }

  async mounted() {
    let cid = 0;
    try {
      cid = JSON.parse(LocalStorage.getWithTimeout("cc")).id;
    } catch {
      console.error("not customer logged found");
    }

    await this.loadData(cid);
  }

  async loadData(customerId: number) {
    let url = `${Settings.HostName}/api/publicvouchers/customer-vouchers/${customerId}`;
    let data = await new CrudService().httpGet(url);
    if (data == null || data.ok === false) {
      console.error("Crash getting my vouchers");
      return;
    }

    this.data = data.model;
  }

  isRecharge(movement: any): boolean {
    return !Format.IsNull(movement) && !movement.amount.startsWith("-");
  }
}
